/**
 * Created by Viacheslav Stepanian on 24.06.2026
 */

const HungryGamesCustomer = function (unit, options) {
    UnitComponent.call(this, unit);

    this.duration = HungryGamesCustomer.LEVEL_DURATION;
    this.levelStartTime = options.lt;
    this.rewarded = options.rw;

    this.shadowCustomerState();
};

HungryGamesCustomer.prototype = Object.create(UnitComponent.prototype);
HungryGamesCustomer.prototype.constructor = HungryGamesCustomer;

HungryGamesCustomer.prototype.getCustomer = function () {
    return this.unit.findComponent(Customer);
};

HungryGamesCustomer.prototype.getTimeLeft = function () {
    return Math.max(0, (this.levelStartTime || Date.now()) + this.duration - Date.now());
};

HungryGamesCustomer.prototype.save = function (data) {
    if (this.levelStartTime) {
        data.lt = this.levelStartTime;
    }
    if (this.rewarded) {
        data.rw = 1;
    }
};

HungryGamesCustomer.prototype.shadowCustomerState = function () {
    const customer = this.getCustomer();
    customer.exactStageIngredients = true;
    const setState = customer._setState.bind(customer);

    customer._setState = (state, recipe, time, needsFirstRecipe, restore) => {
        const previousState = customer.getState();

        setState(state, recipe, time, needsFirstRecipe, restore);

        this.onStateChanged(state, previousState, restore);
    };

    const canCook = customer.canCook.bind(customer);
    customer.canCook = () => canCook() && !this.isLevelTimeUp();
};

HungryGamesCustomer.prototype.isLevelTimeUp = function () {
    if (this.needLoseSequence || this.losing) {
        return true;
    }

    return Boolean(this.hasLevelTimer() && this.levelStartTime && this.getTimeLeft() === 0);
};

HungryGamesCustomer.prototype.onStateChanged = function (currentState, previousState) {
    if (previousState === Customer.STATE_RECIPE && currentState !== Customer.STATE_EMPTY && this.levelStartTime) {
        const mission = HungryGamesCustomer.getMission();
        if (mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
            mission.logic.logEvent(Mission.EVENTS.MISSION_STAGE_TIME, { value: Math.round((Date.now() - this.levelStartTime) / 1000) });
            mission.logic.logEvent(HungryGamesCustomer.EVENTS.ORDER_ENERGY_COMPLETE + Math.round(cleverapps.lives.amount / 10) * 10, { itemId: `${mission.result}` });
        }
    }

    if (currentState === Customer.STATE_RECIPE) {
        if (!this.levelStartTime) {
            this.levelStartTime = Date.now();
            this.unit.save();

            const mission = HungryGamesCustomer.getMission();
            if (mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE && mission.result !== HungryGamesLogic.LEVELS_AMOUNT) {
                mission.logic.logEvent(HungryGamesCustomer.EVENTS.ORDER_ENERGY_START + Math.round(cleverapps.lives.amount / 10) * 10, { itemId: `${mission.result}` });
            }
        }

        this.startLevelTimeout();
        this.startOrderQuest();
    } else {
        this.clearLevelTimeout();

        if (this.levelStartTime) {
            this.levelStartTime = undefined;
            this.unit.save();
        }
    }

    if (this.view) {
        this.view.restoreState();
    }

    if (currentState === Customer.STATE_EMPTY) {
        const mission = HungryGamesCustomer.getMission();
        if (mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
            const recipeTemplate = this.generateOrder(mission.result);
            if (recipeTemplate) {
                this.getCustomer().order(new CustomerRecipe(recipeTemplate));
            }
        }
    }

    if (currentState !== Customer.STATE_READY && this.rewarded) {
        this.rewarded = undefined;
        this.unit.save();
    }

    if (currentState === Customer.STATE_COOKING) {
        this.completing = true;
    }

    if (currentState === Customer.STATE_READY) {
        this.runCompleteSequence();
    }
};

HungryGamesCustomer.prototype.runCompleteSequence = function () {
    const location = Map2dLocation.currentLocation;

    cleverapps.focusManager.display({
        focus: "HungryGamesOrderComplete",
        stack: true,
        actions: [
            (f) => {
                if (this.rewarded || !this.unit) {
                    f();
                    return;
                }

                this.rewarded = true;
                this.unit.save();

                this.unit.setPrizes();

                const recipe = this.getCustomer().recipe;
                const reward = recipe ? recipe.order.flatMap(({ unit, amount }) => Array.from({ length: amount || 1 }, () => unit)) : [];
                if (reward.length) {
                    location.spawn(reward, this.unit, { radius: Map2d.RADIUS_SMALL });
                }

                const mission = HungryGamesCustomer.getMission();
                if (mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
                    this.rewardList = new RewardsList({ mission: { missionType: mission.type, amount: 1 } }, { event: cleverapps.EVENTS.EARN.OTHER });
                    this.rewardList.receiveRewards();
                }

                f();
            },
            (f) => {
                if (!this.playAnimation("eat", f)) {
                    cleverapps.timeouts.setTimeout(f, 600);
                    return;
                }

                cleverapps.timeouts.setTimeout(f, HungryGamesCustomer.ANIMATION_TIMEOUT);
            },
            (f) => {
                if (!this.rewardList) {
                    f();
                    return;
                }

                const rewardList = this.rewardList;
                this.rewardList = undefined;

                rewardList.collectRewardsAnimation(this.unit, { callback: f });
                cleverapps.timeouts.setTimeout(f, HungryGamesCustomer.ANIMATION_TIMEOUT);
            },
            (f) => {
                const quests = location.quests;
                const quest = quests.quests && quests.quests.find((candidate) => candidate.id.startsWith("hungrygames_order"));
                if (quest) {
                    quest.progress = quest.goal;
                    quests.removeFinishedQuest(quest);
                }
                f();
            },
            (f) => {
                const mission = HungryGamesCustomer.getMission();
                if (mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE && mission.result < HungryGamesLogic.LEVELS_AMOUNT) {
                    new HungryGamesWindow(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                } else {
                    f();
                }
            },
            (f) => {
                const customer = this.unit && this.getCustomer();
                if (customer) {
                    customer.reset();
                }

                this.completing = undefined;
                if (customer) {
                    customer.onUpdateState();
                }

                HungryGamesMerge3Adapter.checkCustomer();
                f();
            }
        ]
    });
};

HungryGamesCustomer.prototype.getOrderRewards = function () {
    const mission = HungryGamesCustomer.getMission();
    return mission && { mission: { missionType: mission.type, amount: 1 } };
};

HungryGamesCustomer.prototype.hasLevelTimer = function () {
    return HungryGamesCustomer.SHORT_TIMER_ENABLED;
};

HungryGamesCustomer.prototype.startOrderQuest = function () {
    const mission = HungryGamesCustomer.getMission();
    if (!mission) {
        return;
    }

    const id = `hungrygames_order_${mission.result}`;
    const quests = Map2dLocation.currentLocation.quests;
    const config = QuestsConfig[cleverapps.meta.selectedLocationId()];

    if (config && config[id] && quests.startQuests && !quests.isRunning(id)) {
        quests.applyDynamicFilter();
        quests.startQuests([config[id]]);
    }
};

HungryGamesCustomer.prototype.startLevelTimeout = function () {
    this.clearLevelTimeout();

    if (!this.hasLevelTimer()) {
        return;
    }

    const timeLeft = this.getTimeLeft();

    this._levelTimeout = cleverapps.timeouts.setTimeout(() => {
        this.clearLevelTimeout();
        this.startLoseSequence();
    }, timeLeft);
};

HungryGamesCustomer.prototype.startLoseSequence = function () {
    const mission = HungryGamesCustomer.getMission();
    if (!mission || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE || this.needLoseSequence || this.losing) {
        return;
    }

    mission.logic.logEvent(HungryGamesCustomer.EVENTS.ORDER_ENERGY_LOSE, { value: cleverapps.lives.amount, itemId: `${mission.result}` });

    this.needLoseSequence = true;

    cleverapps.placements.onFocusLostListenerPlacements();
};

HungryGamesCustomer.prototype.runLoseSequence = function () {
    this.needLoseSequence = undefined;

    const mission = HungryGamesCustomer.getMission();
    if (!mission || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
        return;
    }

    this.losing = true;

    cleverapps.focusManager.display({
        focus: "HungryGamesLose",
        actions: [
            (f) => {
                if (mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
                    mission.logic.loseCompetition();
                }
                f();
            },
            (f) => {
                if (this.unit && Map2d.currentMap) {
                    Map2d.currentMap.focusOnUnit(this.unit, {
                        allowScrollWithFocus: true,
                        skipFocusReport: true,
                        callback: f
                    });
                } else {
                    f();
                }
            },
            (f) => {
                const customer = this.unit && this.getCustomer();
                if (customer && customer.getState() !== Customer.STATE_EMPTY) {
                    customer.reset();
                }
                f();
            },
            (f) => {
                if (!this.playAnimation("lose", f)) {
                    f();
                }
            },
            (f) => {
                new HungryGamesWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                this.losing = undefined;

                if (mission.logic.state === HungryGamesLogic.STATES.LOST) {
                    new HungryGamesCooldownWindow(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                } else {
                    f();
                }
            },
            (f) => {
                HungryGamesMerge3Adapter.checkCustomer();
                f();
            }
        ]
    });
};

HungryGamesCustomer.prototype.playAnimation = function (name, callback) {
    const view = this.unit && this.unit.onGetView();
    const sprite = view && view.sprite;

    if (!(sprite instanceof cleverapps.Spine) || !sprite.hasAnimation(name) || (cleverapps.abExperiments.getGroup(ABExperiments.Tests.hungryGamesBalance) === "A")) {
        return false;
    }

    sprite.setAnimation(0, name, false);
    sprite.setCompleteListener(() => {
        sprite.setCompleteListener();
        callback();
    });

    cleverapps.effects.fire(`hungry_games.customer.${name}`);
    return true;
};

HungryGamesCustomer.prototype.clearLevelTimeout = function () {
    if (this._levelTimeout) {
        cleverapps.timeouts.clearTimeout(this._levelTimeout);
        this._levelTimeout = undefined;
    }
};

HungryGamesCustomer.prototype.generateOrder = function (level) {
    return HungryGamesCustomer.RECIPES_CONFIG[level];
};

HungryGamesCustomer.prototype.destructor = function () {
    runCleaners(this);

    this.clearLevelTimeout();
};

HungryGamesCustomer.getMission = function () {
    return cleverapps.missionManager.getRunningMissions().find((mission) => Mission.GetMissionType(mission.type) === Mission.TYPE_HUNGRY_GAMES && MissionManager.hasProperLocation(mission.type));
};

HungryGamesCustomer.findCustomer = function () {
    if (!Map2d.currentMap) {
        return undefined;
    }

    const unit = Map2d.currentMap.listAvailableUnitsInRegion("hungry", { code: "hungry" })[0];
    return unit && unit.findComponent(HungryGamesCustomer);
};

HungryGamesCustomer.ANIMATION_TIMEOUT = cleverapps.parseInterval("6 seconds");
HungryGamesCustomer.LEVEL_DURATION = cleverapps.parseInterval("30 minutes");
HungryGamesCustomer.SHORT_TIMER_ENABLED = true;

HungryGamesCustomer.EVENTS = {
    ORDER_ENERGY_START: "hg_order_start-",
    ORDER_ENERGY_COMPLETE: "hg_order_complete-",
    ORDER_ENERGY_LOSE: "hg_order_lose-"
};

HungryGamesCustomer.calcMineDrop = function (energy) {
    const mission = HungryGamesCustomer.getMission();
    if (!mission || !Map2d.currentMap) {
        return 0;
    }

    if (mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
        return 0;
    }

    return Math.floor(energy / 5);
};
